import {commonValidatorWhitelistedIp} from '@modules/client/forms/commonValidatorWhitelistedIp';

export const validate = (values) => {
    return commonValidatorWhitelistedIp(values);
};

export default validate;
